import React from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import { SectionHeader } from "../layout/SectionHeader";
import { PRIMARY } from "../../constants";
import { PaymentMethodLogoBox } from "../PaymentMethodLogoBox";
import { profileFormRowSpacing, profileSubsectionShellSx } from "../../profileFieldStyles";

const paymentMethodLabelSx = {
  fontFamily: "Rubik, sans-serif",
  fontWeight: 700,
  fontSize: "0.95rem",
  textAlign: "left",
  lineHeight: 1.35,
  minWidth: 0,
};

const paymentMethodRowSx = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
  minWidth: 0,
};

const paymentMethodGridSx = {
  display: "grid",
  width: "100%",
  gap: profileFormRowSpacing,
  gridTemplateColumns: {
    xs: "repeat(1, minmax(0, 1fr))",
    sm: "repeat(2, minmax(0, 1fr))",
    md: "repeat(3, minmax(0, 1fr))",
    lg: "repeat(4, minmax(0, 1fr))",
  },
};

function PaymentMethodRow({ metodo, checked, readOnly, onToggle }) {
  const isMutedReadOnly = readOnly && !checked;

  const checkboxSx = readOnly
    ? {
        color: isMutedReadOnly ? "rgba(0, 0, 0, 0.38)" : "rgba(0, 0, 0, 0.54)",
        "&.Mui-checked": { color: "#000000" },
        "&.Mui-checked.Mui-disabled": { color: "#000000" },
        p: 0.5,
      }
    : {
        color: PRIMARY,
        "&.Mui-checked": { color: PRIMARY },
        p: 0.5,
      };

  return (
    <Box sx={paymentMethodRowSx}>
      <Checkbox
        checked={checked}
        disabled={readOnly}
        onChange={readOnly ? undefined : onToggle}
        inputProps={{
          "aria-label": `${metodo.descrizione}. ${checked ? "Selezionato" : "Non selezionato"}`,
        }}
        sx={checkboxSx}
      />
      <PaymentMethodLogoBox urlLogo={metodo.urlLogo} alt={metodo.descrizione} muted={isMutedReadOnly} />
      <Typography
        sx={{
          ...paymentMethodLabelSx,
          color: isMutedReadOnly ? "#9e9e9e" : "#000000",
        }}
      >
        {metodo.descrizione}
      </Typography>
    </Box>
  );
}

export function MetodiPagamento({
  metodiPagamenti,
  paymentSelectedIds,
  readOnly = false,
  togglePaymentMethodId,
}) {
  return (
    <Box sx={profileSubsectionShellSx}>
      <SectionHeader title="Metodi di pagamento accettati sul tuo e-commerce" />
      <Box sx={paymentMethodGridSx}>
        {metodiPagamenti.map((metodo) => {
          const selected = paymentSelectedIds.includes(metodo.id);
          return (
            <PaymentMethodRow
              key={metodo.id}
              metodo={metodo}
              checked={selected}
              readOnly={readOnly}
              onToggle={() => togglePaymentMethodId?.(metodo.id)}
            />
          );
        })}
      </Box>
    </Box>
  );
}
